module.exports = __webpack_public_path__ + "static/media/checked.22652066.svg";